// removed by extract-text-webpack-plugin
module.exports = {"container":"_3fhaSRwoGc4b3qmAlq_SUC","endCallButton":"_1pIHrgTzTNXEz5BVpdm4y_","activityNotes":"OrMZd2Y39lX8ZZ8IUBcD3"};


//////////////////
// WEBPACK FOOTER
// ./~/extract-text-webpack-plugin/loader.js?{"omit":1,"remove":true}!./~/vue-style-loader!./~/css-loader?{"minimize":true,"sourceMap":true,"localIdentName":"[hash:base64]","modules":true,"importLoaders":true}!./~/vue-loader/lib/style-compiler?{"vue":true,"id":"data-v-a3ebb45e","scoped":false,"hasInlineConfig":false}!./~/less-loader/dist/cjs.js?{"sourceMap":true}!./src/components/rep-call/notepad/notepad.less
// module id = zy2r
// module chunks = 1